require('../bootstrap');

import { createApp } from 'vue';
import PortalApp from './components/PortalApp.vue'
import router from './router'

const getCheckoutIdFromLocalStorage = () => {
    const storage = JSON.parse(localStorage.getItem('application_form') || '{}') || {};

    return !!storage.checkoutId ? storage.checkoutId : null;
};

const app = createApp(PortalApp).use(router);

app.provide('checkoutId', getCheckoutIdFromLocalStorage());

app.mount("#app");